import datemathParser from '@/shared/utils/datemath';

export const parseAbsoluteCursorTimeMs = (cursor?: string): number | undefined => {
  if (!cursor) return undefined;
  const timeMs = Date.parse(cursor);
  return Number.isFinite(timeMs) ? timeMs : undefined;
};

export const parseCursorTimeMs = (
  cursor?: string,
  options?: { date?: Date | number; timezone?: string },
): number | undefined => {
  const absoluteTimeMs = parseAbsoluteCursorTimeMs(cursor);
  if (absoluteTimeMs != null) return absoluteTimeMs;
  if (!cursor) return undefined;

  try {
    const timeMs = datemathParser(cursor, options).getTime();
    return Number.isFinite(timeMs) ? timeMs : undefined;
  } catch {
    return undefined;
  }
};

export const clampCursorTimeMs = (
  timeMs: number,
  fromTimeMs: number,
  toTimeMs: number,
): number => {
  return Math.min(toTimeMs, Math.max(fromTimeMs, timeMs));
};
